import React, { useContext, useState } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import { AppProvider } from "../../ContextApi/AppProvider";
import { PedidoService } from "../../Services/PedidoService";
import Pedido from "../Shared/Interfaces/Pedido";
import IPagamentosPedido from "../Shared/Interfaces/PagamentosPedido";
import ItensPedido from "../Shared/Interfaces/ItensPedido";
import { FiltroRelatorioPedidosPorCliente } from "../Shared/Interfaces/RelatorioPedidosPorCliente";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/pt-br";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DefaultLoader from "../Shared/DefaultLoader";
import colors from "../../theme/colors";
import {
  formatDateToDDMMYYYY,
  formatToBRL,
  limparMascaraDocumento,
  cpfApplyMask,
  cnpjApplyMask,
} from "../../Utils/utils";
export default function RelatorioPedidosDetalhado() {
  const contextApi = useContext(AppProvider);
  const pedidoService = new PedidoService();
  const [loading, setLoading] = useState(false);
  const [dataInicial, setDataInicial] = useState<Dayjs>(
    dayjs().subtract(7, "day")
  );
  const [dataFinal, setDataFinal] = useState<Dayjs>(dayjs());
  const [nomeCliente, setNomeCliente] = useState<string>("");
  const [documentoCliente, setDocumentoCliente] = useState<string>("");

  const [pedidos, setPedidos] = useState<Pedido[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClienteDocumentoChange = (value: string) => {
    const onlyNumbers = limparMascaraDocumento(value);

    if (onlyNumbers.length === 11) {
      const cpf = cpfApplyMask(onlyNumbers);
      setDocumentoCliente(cpf);
      return;
    }

    if (onlyNumbers.length === 14) {
      const cnpj = cnpjApplyMask(onlyNumbers);
      setDocumentoCliente(cnpj);
      return;
    }

    setDocumentoCliente(onlyNumbers);
  };

  const PesquisarPor = () => {
    setLoading(true);
    const filtroPesquisa: FiltroRelatorioPedidosPorCliente = {
      nomeCliente: nomeCliente,
      documentoCliente: documentoCliente,
      dataInicial: dataInicial != null ? dataInicial.toISOString() : null,
      dataFinal: dataFinal != null ? dataFinal.toISOString() : null,

    };

    pedidoService
      .gerarRelatorioPedidosPorCliente(filtroPesquisa)
      .then((response) => {
        if (response.status === 200) {
          // A API pode retornar um array de RelatorioPedidosPorCliente ou um único objeto
          let data = response.data;
          if (!Array.isArray(data)) {
            data = [data];
          }
          
          // Achatar todos os pedidos de todos os clientes em um único array
          const todosPedidos: Pedido[] = [];
          data.forEach((relatorio: any) => {
            if (relatorio && relatorio.pedidos && Array.isArray(relatorio.pedidos)) {
              todosPedidos.push(...relatorio.pedidos);
            }
          });
          
          setPedidos(todosPedidos);
          if (todosPedidos.length === 0) {
            contextApi.showMessage("Nenhum pedido encontrado para os filtros selecionados", true, "info");
          }
        } else if (response.status === 204) {
          setPedidos([]);
          contextApi.showMessage("Nenhum pedido encontrado para os filtros selecionados", true, "info");
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.status === 204) {
          setPedidos([]);
          contextApi.showMessage("Nenhum pedido encontrado para os filtros selecionados", true, "info");
        } else {
          const errorMessage = error.response?.data || "Erro ao buscar pedidos";
          contextApi.showMessage(errorMessage, true, "error");
        }
      });
  };

  React.useEffect(() => {
    //PesquisarPor();
  }, []);

  return (
    <Box sx={{ flexGrow: 1, p: { xs: 1, sm: 2 } }}>
      <Paper sx={{ p: { xs: 1, sm: 2 } }}>
        <Grid container spacing={2}>
          {/* Linha 2 - Filtros */}
          <Grid item xs={12}>
            <Paper sx={{ p: 1, mb: 1 }}>
              <h4 style={{ margin: '0 0 20px 0', color: colors.bluePrimary }}>🔍 Filtros de Pesquisa</h4>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="pt-br"
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      name="nomeCliente"
                      label="Nome do Cliente"
                      fullWidth
                      size="small"
                      variant="outlined"
                      value={nomeCliente}
                      onChange={(e) => setNomeCliente(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      required
                      name="documento"
                      label="CPF ou CNPJ"
                      size="small"
                      fullWidth
                      variant="outlined"
                      value={documentoCliente}
                      onChange={(e) => setDocumentoCliente(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.5}>
                    <DemoContainer components={["DatePicker"]}>
                      <DatePicker
                        label="Data Inicial"
                        defaultValue={dataInicial}
                        value={dataInicial}
                        format="DD/MM/YYYY"
                        onChange={(newValue) =>
                          setDataInicial(newValue ?? dataInicial)
                        }
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                          },
                        }}
                      />
                    </DemoContainer>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.5}>
                    <DemoContainer components={["DatePicker"]}>
                      <DatePicker
                        value={dataFinal}
                        onChange={(newValue) =>
                          setDataFinal(newValue ?? dataFinal)
                        }
                        label="Data Final"
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                          },
                        }}
                      />
                    </DemoContainer>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2}>
                    <Button
                      variant="contained"
                      size="large"
                      disabled={loading}
                      sx={{ height: "40px", width: "100%" }}
                      onClick={() => PesquisarPor()}
                    >
                      {loading ? (
                        <DefaultLoader
                          height="2.5em"
                          width="2.5em"
                          colors={[
                            "#1876D2",
                            "#1876D2",
                            "#1876D2",
                            "#1876D2",
                            "#1876D2",
                          ]}
                          textInfo="Buscando..."
                        />
                      ) : (
                        "Pesquisar"
                      )}
                    </Button>
                  </Grid>
                </Grid>
              </LocalizationProvider>
            </Paper>
          </Grid>

          {/* Linha 3 - Tabela de Resultados */}
          <Grid item xs={12}>
            <Paper sx={{ p: 1, mb: 1 }}>
              <h4 style={{ margin: '0 0 20px 0', color: colors.bluePrimary }}>📊 Resultados</h4>
              
              <Paper sx={{ p: 2, height: "100%", boxShadow: 1, border: '1px solid #e0e0e0' }}>
                {pedidos.length > 0 ? (
                  <>
                    <TableContainer sx={{ overflowX: "auto" }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f5f5f5' }}>Nome do Cliente</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f5f5f5' }}>Data do Pedido</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f5f5f5' }}>Valor do Pedido</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f5f5f5' }}>Forma de Pagamento</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f5f5f5' }}>Produtos Vendidos</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {pedidos
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((pedido) => (
                              <TableRow key={pedido.id}>
                                <TableCell>
                                  <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                                    {pedido.cliente?.nome || "N/A"}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography variant="body2">
                                    {formatDateToDDMMYYYY(pedido.dataCriacao)}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography variant="body2" sx={{ fontWeight: 'medium', color: colors.bluePrimary }}>
                                    {formatToBRL(pedido.valorTotal)}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography variant="body2">
                                    {pedido.pagamentosPedido && pedido.pagamentosPedido.length > 0
                                      ? pedido.pagamentosPedido.map((pagamento: IPagamentosPedido) => pagamento.formaPagamento).join(", ")
                                      : pedido.formaPagamento || "N/A"}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  {pedido.itensPedido && pedido.itensPedido.length > 0 ? (
                                    <Box>
                                      {pedido.itensPedido.map((item: ItensPedido, index: number) => (
                                        <Typography 
                                          key={index} 
                                          variant="body2" 
                                          sx={{ mb: index < pedido.itensPedido.length - 1 ? 0.5 : 0 }}
                                        >
                                          <strong>{item.descricao || "Produto sem descrição"}</strong> - Qtd: {item.quantidade}
                                        </Typography>
                                      ))}
                                    </Box>
                                  ) : (
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                      Nenhum item encontrado
                                    </Typography>
                                  )}
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 50]}
                      component="div"
                      count={pedidos.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </>
                ) : (
                  <Box sx={{ textAlign: "center", py: 8 }}>
                    <Typography variant="body2" sx={{ color: "text.secondary" }}>
                      Nenhum pedido encontrado para os filtros selecionados
                    </Typography>
                  </Box>
                )}
              </Paper>
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}

